import React from 'react';
import { useLocation } from 'react-router-dom';

import { getAdminAppUrl, getConsoleAppUrl } from '@/config/runtimeUrls';

type HandoffErrorPageProps = {
  appTarget: 'admin' | 'console';
};

const readParam = (search: string, key: string): string => {
  const params = new URLSearchParams(search);
  return String(params.get(key) || '').trim();
};

const resolveSourceTarget = (search: string, fallback: 'admin' | 'console'): 'admin' | 'console' => {
  const source = readParam(search, 'source').toLowerCase();
  if (source === 'admin' || source === 'console') return source;
  return fallback;
};

export default function HandoffErrorPage({ appTarget }: HandoffErrorPageProps) {
  const location = useLocation();
  const sourceTarget = resolveSourceTarget(location.search, appTarget);
  const targetHost = readParam(location.search, 'targetHost');
  const reason =
    readParam(location.search, 'reason') ||
    'We could not complete the secure cross-host handoff for your session.';
  const sourceLabel = sourceTarget === 'admin' ? 'Admin' : 'Console';
  const sourceUrl = sourceTarget === 'admin' ? getAdminAppUrl() : getConsoleAppUrl();

  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: '#0b1220',
        color: '#e5edf8',
        padding: 24,
        fontFamily: 'Inter, system-ui, sans-serif',
      }}
    >
      <section
        style={{
          width: '100%',
          maxWidth: 520,
          borderRadius: 14,
          border: '1px solid rgba(148, 163, 184, 0.25)',
          background: 'rgba(17, 24, 39, 0.94)',
          padding: 24,
        }}
      >
        <h1 style={{ margin: 0, fontSize: 26, color: '#fff' }}>Secure navigation failed</h1>
        <p style={{ marginTop: 12, marginBottom: 8, color: '#9fb0ca', lineHeight: 1.5 }}>{reason}</p>
        {targetHost ? (
          <p style={{ marginTop: 0, marginBottom: 20, color: '#9fb0ca', lineHeight: 1.5 }}>
            Target host: <strong style={{ color: '#fff' }}>{targetHost}</strong>
          </p>
        ) : null}
        <button
          type="button"
          onClick={() => window.location.replace(sourceUrl)}
          style={{
            border: 'none',
            borderRadius: 9,
            background: '#f97316',
            color: '#fff',
            fontWeight: 700,
            padding: '10px 14px',
            cursor: 'pointer',
          }}
        >
          Return to {sourceLabel}
        </button>
      </section>
    </main>
  );
}
